import type { ExperimentAssignment, ExperimentsData } from '@/components/_shared/contexts/ExperimentsContext';
import { LISTINGS_DESKTOP_TWO_RAILS_EXPERIMENT } from '../../common/constants';

export function isListingsDesktopTwoRailsVariant(assignment: ExperimentAssignment | undefined): boolean {
  return assignment?.groupName?.toLowerCase() === 'test';
}

export function getListingsDesktopTwoRailsFromExperiments(experiments: ExperimentsData | undefined): boolean {
  if (!experiments) {
    return false;
  }
  return isListingsDesktopTwoRailsVariant(experiments[LISTINGS_DESKTOP_TWO_RAILS_EXPERIMENT.experimentName]);
}
